export class User {
    userId?: number;
    id?: number;
    username?: string;
    name?: string;
    localizacion?: string;
    telefono?: string;
    email?: string;
    password?: string;
    currentPassword?: string;
    photo?: string;
    typePhoto?: string;
    connected?: boolean;
    enabled?: boolean;
    token?: string;
    role?: string;
    roleName?: string;
    roles?: any;
    firstName?: any;
    lastName?: any;
    territoryId?: any;
    territoryName?: any;
    branchId?: number;
    lang?: string;
    sectionOtherDocuments?: boolean;
    assistanceModule?: boolean;
}

export class tiposContratos {
    id?: number;
    name?: string;
}
